import { Route, Switch } from 'react-router-dom'

import { PrivateRoute } from 'core/ui/components/private-route/PrivateRoute'

import { AwardedProposalConfirmationPage } from './AwardedProposalConfirmationPage'
import { AwardedProposalPage } from './AwardedProposalPage'
import { RfpProvider } from './contexts/RfpContext'
import { ProposalPage } from './ProposalPage'
import { RfpHistoryPage } from './RfpHistoryPage'

type RfpPageProps = {
  match: {
    path: string
  }
}

export default function RfpPage({ match }: RfpPageProps): JSX.Element {
  const { path } = match

  return (
    <RfpProvider>
      <Switch>
        <Route
          path={`${path}/:id/feedback`}
          render={props => <ProposalPage {...props} disabled />}
          exact
        />
        <Route path={`${path}/:id`} component={ProposalPage} exact />
        <Route path={`${path}/:id/award`} component={AwardedProposalPage} exact />
        <Route
          path={`${path}/:id/award/confirmation`}
          component={AwardedProposalConfirmationPage}
          exact
        />
        <PrivateRoute path={`${path}/`} component={RfpHistoryPage} />
      </Switch>
    </RfpProvider>
  )
}
